import React from 'react';
import { WidgetEditorProps } from '../../ContentMapping/ContentMapping';
import './iGEMVideo.css';

/**
 * Let the user create an embedded video by specifying the link and a percentage width.
 * Height will be automatic based on the aspect ratio.
 *
 * Last Modified
 * Diandre Sabale
 * October 11, 2022
 */


// TODO: This class is not using "controlled" form inputs. I would suggest switching it to controlled
// sometime in the future. For now it's fine because it works and we're under a deadline.
// TODO: Use the component within Video.tsx instead of re-doing the video logic.
export const iGEMVideoEditor: React.FC<WidgetEditorProps> = ({
	originalContent,
	editedContent,
	setEditedContentOnChange
}) => {
	let videoLink: string = editedContent.video_videoLink || "";
	let videoWidth: number = editedContent.video_videoWidth || 0;
	let videoHeight: number = editedContent.video_videoHeight || 0;

	return <>
		<h3>Video Link (from iGEM Video Universe)</h3>
		<input type="text" value={videoLink}
			onChange={(e) => setEditedContentOnChange("video_videoLink", e.target.value)} />
		<h3>Video Width</h3>
		<input type="text" value={videoWidth}
			onChange={(e) => setEditedContentOnChange(
				"video_videoWidth",
				Number(e.target.value)
			)} />
		<h3>Video Height</h3>
		<input type="text" value={videoHeight}
			onChange={(e) => setEditedContentOnChange(
				"video_videoHeight",
				Number(e.target.value)
			)} />
	</>;
}